import moment from 'moment';
import React, { Component } from 'react';
import Footer from '../SubComponents/Footer/Footer';
import Header from '../SubComponents/Header/Header';
import { paymentCompleteRedirect, server } from '../../utilities/api';
// import { ProgressStep } from '../SubComponents/ProgressIndicator/ProgressIndicator';
// import ProgressIndicator from '../SubComponents/ProgressIndicator/ProgressIndicatorContainer';
import './Pay.css';
import { addCustomTagEvent } from '../../utilities/customTag';

function getConvergeUrl(s) {
  switch (s) {
    case 'local':
      return 'https://demo.convergepay.com/hosted-payments/';
    case 'staging':
      return 'https://demo.convergepay.com/hosted-payments/';
    case 'alignet':
    case 'production':
      return 'https://www.convergepay.com/hosted-payments/';
    default:
      console.error('No Server Specified!');
      throw new Error('You are not doing this right.');
  }
}

function getAlignetUrl(s) {
  switch (s) {
    case 'local':
      return 'https://integracion.alignetsac.com/VPOS2/faces/pages/startPayme.xhtml';
    case 'alignet':
    case 'staging':
      return 'https://integracion.alignetsac.com/VPOS2/faces/pages/startPayme.xhtml';
    case 'production':
      return 'https://vpayment.verifika.com/VPOS2/faces/pages/startPayme.xhtml';
    default:
      console.error('No Server Specified!');
      throw new Error('You are not doing this right.');
  }
}

export default class Pay extends Component {

  constructor(props) {
    super(props);
    this.state = {
      redirectURL: undefined
    }
  }
  // submitRef: HTMLElement | null;

  componentDidMount() {
    addCustomTagEvent({
        event: 'AddPaymentInfo',
        category: 'Cart',
        label: 'Pay',
        value: this.props.cartValue,
        paymentDetails: {
            automatic: true,
            isValid: ((this.props.sessionToken !== undefined || this.props.signedAuthorizationRequest !== undefined) && (this.props.purchaseCode !== undefined) && (this.props.emailAddress !== undefined)),
            locationCurrency: this.props.currency,
            locationName: this.props.locationName,
            cartValue: this.props.cartValue
        }
    });
    if ((this.props.sessionToken || this.props.signedAuthorizationRequest !== undefined) && this.props.purchaseCode && this.props.emailAddress) {
      if (this.submitRef) this.submitRef && this.submitRef.click();
      else if (document.getElementById('paymentConfirmation')) {
        document.getElementById('paymentConfirmation').submit();
      }
    }
  }

  getRedirectURL = async function (purchaseCode) {
    const redirectURL = await paymentCompleteRedirect(purchaseCode);
    console.log(`Redirect URL: `, redirectURL);
    this.setState({
      redirectURL: redirectURL
    });
  }

  onClickNext = () => {
    return false;
  }

  onClickPrev = () => {
    this.props.transitionBack().catch((error) => {
      console.error('Failed to go back from pay: ' + error);
    });
  }

  render() {
    const convergeUrl = getConvergeUrl(server);
    const alignetUrl = getAlignetUrl(server);
    const sessionToken = this.props.sessionToken;
    const isZero = sessionToken === '0Dollars';
    const signedAuthorizationRequest = this.props.signedAuthorizationRequest;
    const purchaseCode = this.props.purchaseCode;
    const emailAddress = this.props.emailAddress;
    const firstName = this.props.firstName;
    const lastName = this.props.lastName;

    if (sessionToken && purchaseCode) {
      if (isZero) {
        this.getRedirectURL(purchaseCode);
      }
      return (
        <div className={'AppContainer'}>
          <Header
            header={this.props.locationName.toLocaleUpperCase()}
            subHeader={moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
            hideOnMobile={true}
          />
          {/* <ProgressIndicator currentStep={ProgressStep.Pay} /> */}
          <div className={'Pay-Redirect-Text'}>
            {this.props.languageObj.render.session_token.pay_redirect_pre}{isZero ? this.props.languageObj.render.session_token.pay_redirect_pre_zero_true : this.props.languageObj.render.session_token.pay_redirect_pre_zero_false}{this.props.languageObj.render.session_token.pay_redirect_pre_page}<br />{this.props.languageObj.render.session_token.pay_redirect_post}{isZero ? this.props.languageObj.render.session_token.pay_redirect_post_zero_true : this.props.languageObj.render.session_token.pay_redirect_post_zero_false}{this.props.languageObj.render.session_token.pay_redirect_post_button}
          </div>
          {isZero && this.state.redirectURL !== undefined ? (
            <div className={'Pay'}>
              <form action={this.state.redirectURL} method="GET" target="_parent">
                <input type="submit" className={'Pay-button'} value="Redirect Now" name="submit" ref={(x) => this.submitRef = x} />
              </form>
            </div>
          ) :
          isZero ? (
            <div className={'Pay-Redirect-Text'}>
              Redirecting Directly To Ctrl V!
            </div>
          ) : (
            <div className={'Pay'}>
              <form action={convergeUrl} method="POST" target="_parent">
                <input type="hidden" name="ssl_txn_auth_token" value={sessionToken} />
                <input type="hidden" name="ssl_invoice_number" value={purchaseCode} />
                <input type="hidden" name="ssl_email" value={emailAddress} />
                <input type="hidden" name="ssl_first_name" value={firstName} />
                <input type="hidden" name="ssl_last_name" value={lastName} />
                <input type="submit" className={'Pay-button'} value="Pay" name="submit" ref={(x) => this.submitRef = x} />
              </form>
            </div>
          )}
          <Footer
            nextName={this.props.languageObj.render.session_token.next_name}
            prevName={this.props.languageObj.render.session_token.prev_name}
            nextDisabled={true}
            prevDisabled={false}
            handleClickNext={this.onClickNext}
            handleClickPrev={this.onClickPrev}
            nextHidden={true}
          />
        </div>
      );
    }
    else if (signedAuthorizationRequest && purchaseCode) {
      // return;
      try {
      return (
        <div className={'AppContainer'}>
          <Header
            header={this.props.locationName.toLocaleUpperCase()}
            subHeader={moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
            hideOnMobile={true}
          />
          {/* <ProgressIndicator currentStep={ProgressStep.Pay} /> */}
          {/* <div className={'Pay-Redirect-Text'}>
            {this.props.languageObj.render.session_token.pay_redirect_pre}{isZero ? this.props.languageObj.render.session_token.pay_redirect_pre_zero_true : this.props.languageObj.render.session_token.pay_redirect_pre_zero_false}{this.props.languageObj.render.session_token.pay_redirect_pre_page}<br />{this.props.languageObj.render.session_token.pay_redirect_post}{isZero ? this.props.languageObj.render.session_token.pay_redirect_post_zero_true : this.props.languageObj.render.session_token.pay_redirect_post_zero_false}{this.props.languageObj.render.session_token.pay_redirect_post_button}
          </div> */}
          {
            /* Somehow load dynamically:
              - Language
              - VR Stations (translated)
            */
            <div className={'Pay'}>
              <form className="alignet-form-vpos2" action={alignetUrl} method="POST" id="paymentConfirmation" name="paymentConfirmation">
                <input type="hidden" name="acquirerId" value={signedAuthorizationRequest.AcquirerId} />
                <input type="hidden" name="idCommerce" value={signedAuthorizationRequest.IdCommerce} />
                <input type="hidden" name="purchaseAmount" value={signedAuthorizationRequest.Amount} />
                <input type="hidden" name="purchaseCurrencyCode" value={signedAuthorizationRequest.CurrencyCode} />
                <input type="hidden" name="purchaseOperationNumber" value={signedAuthorizationRequest.OrderId} />
                <input type="hidden" name="purchaseVerification" value={signedAuthorizationRequest.Signature} />
                <input type="hidden" id="language" name="language" value="ES"/>
                <input type="hidden" id="programmingLanguage" name="programmingLanguage" value="NodeJS"/>
                <input type="hidden" id="descriptionProducts" name="descriptionProducts" value="VR Stations"/>
                <input type="hidden" id="reserved1" name="reserved1" value=""/>
                <input type="hidden" id="shippingAddress" name="shippingAddress" value=""/>
                <input type="hidden" id="shippingCity" name="shippingCity" value=""/>
                <input type="hidden" id="shippingCountry" name="shippingCountry" value="CR"/>
                <input type="hidden" id="shippingEmail" name="shippingEmail" value={emailAddress}/>
                <input type="hidden" id="shippingFirstName" name="shippingFirstName" value={firstName}/>
                <input type="hidden" id="shippingLastName" name="shippingLastName" value={lastName}/>
                <input type="hidden" id="shippingState" name="shippingState" value=""/>
                <input type="hidden" id="shippingZIP" name="shippingZIP" value=""/>
                <input type="hidden" id="userCodePayme" name="userCodePayme" value=""/>
                <input type="hidden" id="userCommerce" name="userCommerce" value=""/>
                {/* <input type="submit" className={'Pay-button'} value="Pay" name="submit" ref={(x) => this.submitRef = x} /> */}
              </form>
            </div>
          }
          <Footer
            nextName={this.props.languageObj.render.session_token.next_name}
            prevName={this.props.languageObj.render.session_token.prev_name}
            nextDisabled={true}
            prevDisabled={false}
            handleClickNext={this.onClickNext}
            handleClickPrev={this.onClickPrev}
            nextHidden={true}
          />
        </div>
      );
        } catch (err) {
          console.error(err);
          return;
        }
    } else {
      return (
        <div className={'AppContainer'}>
          <Header
            header={this.props.locationName.toLocaleUpperCase()}
            subHeader={moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
            hideOnMobile={true}
          />
          <div className={'Pay'}>
            {this.props.languageObj.render.no_session_token.pay}
          </div>
          <Footer
            nextName={this.props.languageObj.render.no_session_token.next_name}
            prevName={this.props.languageObj.render.no_session_token.prev_name}
            nextDisabled={true}
            prevDisabled={false}
            handleClickNext={this.onClickNext}
            handleClickPrev={this.onClickPrev}
            nextHidden={true}
          />
        </div>
      );
    }
  }
}
